import React from "react";
import Layout from "../components/layout";
import "../styles/app.scss";

export default function ProductSwitchApplication() {
  return (
    <Layout
      title="Product Switch Application"
      metaDescription="HSBC Intermediaries Product Switch Application Instructions"
    >
      <section className="product-switch-application">
        <h2>We have recently made some changes to the way we amend rates on existing applications.</h2>
        <h2>Depending on the type of application, you will need to request the amendment as follows:</h2>

        <div>
          <ul>
            <li>
              <strong>Product Switch application:</strong>
              <ul className="product-switch-application__list">
                <li className="product-switch-application__list-item">
                  <strong>If a Fee Saver rate or the booking fee has been capitalised:</strong>
                  <ul className="product-switch-application__sub-list">
                    <li className="product-switch-application__sub-list-item">
                      Cancel the existing application using the ‘Cancel application’ option on the Broker Platform
                    </li>
                    <li className="product-switch-application__sub-list-item">
                      Once cancelled, please key a new Product Switch application on the new rate.
                    </li>
                  </ul>
                </li>
                <li className="product-switch-application__list-item">
                  <strong>If the booking fee was already paid up front:</strong>
                  <ul className="product-switch-application__sub-list">
                    <li className="product-switch-application__sub-list-item">
                      Use Chat with us where an agent will process the rate change for you.
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </section>
    </Layout>
  );
}
